import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import SelectFilter from 'components/Select/SelectFilter';

import { WineOption, MarketOption, Option } from 'interface';
import { FilterComparePricesOptions } from 'interface/price';
import { getNameNetwork } from 'modules/Prices/helpers';

const ComparePriceFiltersContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.75);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;
  padding: 30px 20px;
`;

const ComparePriceFilters = ({
  wineId,
  network,
  market,
  options,
  onChangeWine,
  onChangeNetwork,
  onChangeMarket,
  disabled = false
}: {
  wineId: number | null;
  network: string | null;
  market: string | null;
  options: FilterComparePricesOptions;
  // eslint-disable-next-line no-unused-vars
  onChangeWine: (e: number) => void;
  // eslint-disable-next-line no-unused-vars
  onChangeNetwork: (e: string) => void;
  // eslint-disable-next-line no-unused-vars
  onChangeMarket: (e: MarketOption | null) => void;
  disabled?: boolean;
}) => {
  const selectedWine = options.wines.find((wine) => wine.value === wineId);
  return (
    <ComparePriceFiltersContainer>
      <SelectFilter
        selectedOption={
          selectedWine
            ? { label: selectedWine.label, value: selectedWine.value }
            : null
        }
        options={options.wines}
        label={I18n.t('prices.filters.wine2')}
        onChange={(value: WineOption) => onChangeWine(value.value)}
        placeholder={I18n.t('prices.filters.placeholderWine')}
        isClearable={false}
        isDisabled={disabled}
      />
      <SelectFilter
        label={I18n.t('prices.filters.network')}
        placeholder={I18n.t('prices.filters.placeholderNetwork')}
        selectedOption={
          network ? { label: getNameNetwork(network), value: network } : null
        }
        options={options.networks}
        onChange={(value: Option) => onChangeNetwork(value.value)}
        isClearable={false}
        isDisabled={disabled}
      />
      <SelectFilter
        label={I18n.t('prices.filters.market')}
        placeholder={I18n.t('placeholderAll')}
        selectedOption={market}
        options={options.markets}
        onChange={(value: MarketOption) => onChangeMarket(value)}
        isDisabled={disabled}
      />
    </ComparePriceFiltersContainer>
  );
};

export default ComparePriceFilters;
